import React, { useContext, useEffect, useReducer, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  FormControl,
  Select,
  InputBase,
  MenuItem,
  FormControlLabel,
  Switch,
  InputAdornment,
  Tab,
  Tabs,
  Box,
} from "@material-ui/core";
import clxc from "clsx";
import SearchBarWithFilters from "components/search_with_filters";
import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import TableAction from "actions/table_actions";
import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";
import MROButton from "components/buttons";
import useDebounce from "lib/utils/debounce";
import { ToastMessageContext } from "lib/contexts/message_context";
import AddPart from "./AddPartDetails/AddPart";
import PartInfo from "./PartInfo";
import AddIcon from "@material-ui/icons/Add";
import { MaintenanceServices } from "lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation";
import ToolingTable from "./ToolingTable";
import PositiveSwitch from "components/form_components/switch";
import StockInfo from "views/Stores/Parts/Stocks/stockInfo";
import GearRed from "assets/gear-red.svg";
import GearAmber from "assets/AmberGear.png";
import CheckGreen from "assets/green_filled_tick.png";
import AllIcon from "assets/AllTextIcon.svg";


const useStyles = makeStyles(() => ({
  root: {
    height: "100%",
    width: "100%",
    "& .MuiOutlinedInput-multiline": {
      minHeight: "89px",
    },

    "& textarea::placeholder": {
      textTransform: "none !important",
    },

    "& form": {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    bold: {
      fontWeight: 600,
    },
  },
  title: {
    fontSize: "17px",
    marginBottom: "10px",
    marginRight: "20px",
  },
  title2: {
    fontSize: "17px",
    margin: "20px 20px 10px 0px",
  },

  StockInfoDrawer: {
    "& > div[aria-hidden='true']": {
      visibility: "hidden !important",
    },
  },
  stockBtn: {
    borderColor: "#4D4F5C",
    borderRadius: "7px",
    minWidth: "20px",
    height: "30px",
    width: "70px",
    backgroundColor: "#FFB300",
  },
  tabs: {
    minHeight: "36px",
    "& .MuiTab-root": {
      borderRadius: "2px",
      minHeight: "36px",
      minWidth: "36px",
      boxShadow: "1px 1px 3px #00000044",
    },
    "& .MuiTabs-flexContainer": {
      gap: "0.75rem",
      padding: "0.25rem",
    },
    "& .MuiTab-textColorInherit": {
      opacity: 1,
    },
  },
}));

function PartsAndTools(props) {
  const classes = useStyles();
  const {
    bases,
    lineCustomers,
    currentSelectedOrder,
    orderState,
    partsAndToolsStatus
  } = props;

  const message = useContext(ToastMessageContext);

  // const user = JSON.parse(sessionStorage.getItem("user"));

  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize, inProgress, data } = tableState;
  const [issued, setIssued] = useState(true);

  const [tableRefresh, setTableRefresh] = useState(false);

  const [searchText, setSearchText] = useState("");
  const debouncedVal = useDebounce(searchText);

  const [currentSelection, setCurrentSelection] = useState({});
  const [action, setAction] = useState(null);

  const [filters, setFilters] = useState({});
  const [statusFilter, setStatusFilter] = useState("All");
  const [actionDpdOptions, setActionDpdOptions] = useState([]);

  const filterChangeHandler = (key, value) => {
    setFilters(prevState => ({ ...prevState, [key]: value }));
  };

  const getActions = async () => {
    try {
      const { data } = await MaintenanceServices.getActionsDpdOptions({
        id: currentSelectedOrder.id,
      });
      setActionDpdOptions(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getActions();
  }, []);

  const closeHandler = () => {
    setTableRefresh(!tableRefresh);
    // setCreateSection(null);
    setAction(null);
  };
  const tableOptions = {
    ...options,
    page: page,
    search: false,
    total: totalCount,
    pageSize: pageSize,
    searchText: searchText,
    toolbar: false,
  };

  const getList = () => {
    const params = {
      reportable_type: "WorkshopOrder",
      reportable_id: currentSelectedOrder.id,
      search_keyword: debouncedVal,
      page: 1 + page,
      count_per_page: pageSize,
      // to_issued: issued,
      status: statusFilter,
      ...filters
    };

    TableAction.getList(dispatch, message, params, "workshopRequestPart");
  };

  useEffect(() => {
    getList();
  }, [page, debouncedVal, pageSize, filters, statusFilter]);



  // const dataTable = [
  //   {
  //     tool_id: "1870",
  //     part_number: "ABC1234T-09123",
  //     description: "Cleaning Solution - 1L",
  //     call_due: "-",
  //     user: "7",
  //   },
  //   {
  //     tool_id: "098",
  //     part_number: "ABC1234T-09123",
  //     description: "Cleaning Solution - 1L",
  //     call_due: "23/Dec/2020",
  //     user: "7",
  //   },
  //   {
  //     tool_id: "0985",
  //     part_number: "ABC1234T-09123",
  //     description: "Cleaning Solution - 1L",
  //     call_due: "23/Dec/2020",
  //     user: "7",
  //   },
  //   {
  //     tool_id: "7658",
  //     part_number: "ABC1234T-09123",
  //     description: "Cleaning Solution - 1L",
  //     call_due: "23/Dec/2020",
  //     user: "7",
  //   },
  // ];

  const columns = [
    {
      title: "",
      field: "id",
      width: "4%",
      render: (rowData) => <span>&nbsp;</span>,
    },
    {
      title: "Action #",
      field: "action_number",
      editable: 'never',
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        padding: "10px 5px",
      },
    },
    {
      title: "Title",
      field: "action_title",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        width: "19%",
      },
    },
    {
      title: "Part Number",
      field: "part_number",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        width: "11%",
      },
    },
    {
      title: "Description",
      field: "description",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        width: "27%",
      },
    },
    {
      title: "ETA",
      field: "eta",
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
        width: "6%",
      },
    },
    {
      title: "Stock",
      field: "stock",
      render: (rowData) => {
        return <span style={{ color: "#265AE8", textDecoration: "underline", cursor: "pointer" }} onClick={() => { setAction("viewStock"); setCurrentSelection(rowData) }}>
          {rowData?.stock}{" "}
        </span>
      }
    },
    {
      title: "Ordered",
      field: "required_quantity",
    },
    {
      title: "Allocated",
      field: "allocated_quantity",
    },
    {
      title: "Issued",
      field: "issued_quantity",
    },

    {
      title: "Status",
      render: (rowData) => {
        if (rowData?.approval_state === "un_approved" && rowData?.status != null) {
          return (
            <MROButton
              variant="outlined"
              style={{
                backgroundColor: "red",
                textDecoration: "underline",
                color: "white",
                borderRadius: "6px",
                PointerEvent: "none",
                textTransform: "uppercase",
                minWidth: "100px"
              }}
              onClick={() => {
                setAction("partDetails");
                setCurrentSelection(rowData);
              }}
            >
              <Typography style={{ wordWrap: "break-word" }}>
                <span style={{ marginRight: "3px" }}>
                  {/* {rowData?.status?.qty}{" "} */}
                </span>{" "}
                <span style={{ textTransform: "uppercase" }}>{"approval"}</span>
              </Typography>
            </MROButton>
          );
        } else if (
          rowData?.status?.status === "issued" ||
          (rowData?.approval_state === "approved" &&
            rowData?.issued_quantity === rowData?.required_quantity &&
            rowData?.status === null)
        ) {
          return (
            <MROButton
              variant="outlined"
              style={{
                borderColor: "darkgrey",
                textDecoration: "underline",
                color: "darkgrey",
                borderRadius: "6px",
                PointerEvent: "none",
                textTransform: "uppercase",
                minWidth: "100px"
              }}
              onClick={() => {
                setAction("partDetails");
                setCurrentSelection(rowData);
              }}
            >
              <Typography style={{ fontSize: "14px" }}>
                <span style={{ textTransform: "uppercase" }}>
                  {"all issued"}
                </span>
              </Typography>
            </MROButton>
          );
        } else if (
          rowData?.issued_quantity != rowData?.required_quantity &&
          rowData?.status === null
        ) {
          return (
            <MROButton
              variant="outlined"
              style={{
                borderColor: "darkgrey",
                // textDecoration: "underline",
                color: "darkgrey",
                borderRadius: "6px",
                PointerEvent: "none",
                textTransform: "uppercase",
                minWidth: "100px"
              }}
              onClick={() => {
                setAction("partDetails");
                setCurrentSelection(rowData);
              }}
            >
              <Typography style={{ fontSize: "14px" }}>
                <span style={{ textTransform: "uppercase" }}>{"--"}</span>
              </Typography>
            </MROButton>
          );
        } else {
          if (rowData?.status?.color != null) {
            var bgColor =
              rowData?.status?.color === "amber"
                ? "#FFB300"
                : rowData?.status?.color === "green"
                  ? "#4FC605"
                  : rowData?.status?.color === "red"
                    ? "red"
                    : "darkgrey";
          }
          return (
            rowData?.status != null && (
              <MROButton
                variant="outlined"
                style={{
                  backgroundColor: bgColor,
                  textDecoration: "underline",
                  border: "none",
                  color: "white",
                  borderRadius: "6px",
                  PointerEvent: "none",
                  textTransform: "uppercase",
                  minWidth: "100px"
                }}
                onClick={() => {
                  setAction("partDetails");
                  setCurrentSelection(rowData);
                }}
              >
                <Typography>
                  <span style={{ marginRight: "3px", fontSize: "14px" }}>
                    {rowData?.status?.qty}
                  </span>{" "}
                  <span
                    style={{ textTransform: "uppercase", fontSize: "14px" }}
                  >
                    {rowData?.status?.status || ""}
                  </span>
                </Typography>
              </MROButton>
            )
          );
        }
      },
    },
  ];

  const iconStyle = { height: "20px" };

  // Config array for icons and their alt text
  const tabConfig = [
    { src: AllIcon, alt: "All" },
    { src: GearRed, alt: "Red" },
    { src: GearAmber, alt: "Amber" },
    { src: CheckGreen, alt: "Green" },
  ];

  const handleIconFilterChange = (keyItem, value) => {
    TableAction.setPage(dispatch, 0);
    setStatusFilter(value);
  };



  return (
    <>
      <Typography color="primary" className={classes.title}>
        Parts
      </Typography>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Typography
            className={classes.bold}
          // style={{ marginLeft: 1000 }}
          >
            <MROButton
              disabled={!props?.permission.write}
              style={{ width: 140, height: 36, display: orderState === "Closed" && "none" }}
              variant={"contained"}
              color={"secondary"}
              onClick={() => setAction("view")}
              startIcon={<AddIcon size="small" />}
            >
              Add Part
            </MROButton>
          </Typography>
          <SearchBarWithFilters
            handleSearch={(value) => {
              TableAction.setPage(dispatch, 0);
              setSearchText(value);
            }}
            searchText={searchText}
          >
            <Grid style={{ display: "flex", justifyContent: "space-between" }} container>

              <Grid >
                <FormControl size="medium" className={"filter"}>
                  <Select
                    name="workshop_action_id"
                    displayEmpty
                    defaultValue={""}
                    input={<InputBase />}
                    onChange={(e) => filterChangeHandler("workshop_action_id", e.target.value)}
                  >
                    <MenuItem value={""}> Action (All)</MenuItem>
                    {actionDpdOptions.map((e) => (
                      <MenuItem
                        key={e.workshop_action_id}
                        value={e.workshop_action_id}
                      >
                        {e.action_number}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </Grid>
              <Grid style={{ marginTop: "-17px" }}>
                <FormControl style={{ textAlign: "right" }}>


                  <Tabs
                    value={statusFilter}
                    onChange={handleIconFilterChange}
                    indicatorColor="primary"
                    className={classes.tabs}
                  >
                    {tabConfig.map(({ src, alt }, index) => (
                      <Tab key={index} value={alt} icon={<img src={src} alt={alt} style={iconStyle} />} />
                    ))}
                  </Tabs>

                </FormControl>
              </Grid>

            </Grid>
          </SearchBarWithFilters>

          {/* Table */}
          <MaterialTable
            style={{ marginTop: 20 }}
            columns={columns}
            icons={tableIcons}
            title=""
            data={data.data || []}
            isLoading={inProgress}
            options={tableOptions}
            onChangePage={(page) => {
              TableAction.setPage(dispatch, page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              TableAction.setPageSize(dispatch, pageSize);
            }}
            onSearchChange={(search) => {
              TableAction.setSearchText(dispatch, search);
            }}
            totalCount={totalCount}
            page={page}
          />
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Typography color="primary" className={classes.title2}>
            Tools
          </Typography>
          <ToolingTable
            classes={classes}
            currentSelectedOrder={currentSelectedOrder}
          />
          {/* Table */}
          {/* <MaterialTable
            style={{ marginTop: 20 }}
            columns={columnConfig}
            icons={tableIcons}
            title=""
            data={dummyData || []}
            isLoading={inProgress}
            options={tableOptions}
            onChangePage={(page) => {
              TableAction.setPage(dispatch, page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              TableAction.setPageSize(dispatch, pageSize);
            }}
            onSearchChange={(search) => {
              TableAction.setSearchText(dispatch, search);
            }}
            totalCount={totalCount}
            page={page}
          /> */}
        </Grid>
      </Grid>
      {action === "view" && (
        <AddPart
          onClose={() => setAction(null)}
          bases={bases}
          lineCustomers={lineCustomers}
          currentSelectedOrder={currentSelectedOrder}
          actionDpdOptions={actionDpdOptions}
          getList={getList}
        />
      )}
      {action === "partDetails" && (
        <PartInfo
          permission={props?.permission}
          onClose={() => setAction(null)}
          currentSelectedRequest={currentSelection}
          actionDpdOptions={actionDpdOptions}
          getData={getList}
          closeHandler={closeHandler}
          partsAndToolsStatus={partsAndToolsStatus}
        />
      )}
      {action === "viewStock" && currentSelection && (
        <StockInfo
          permission={props.permission}
          action={action}
          currentSelection={{ part_id: currentSelection?.prime_part_id, total_stock: currentSelection?.in_stock || "" }}
          handleClose={() => {
            setAction(null);
            setCurrentSelection(null);
          }}
          baseStations={bases}
          hideEdit
        />
      )}
    </>
  );
}

export default PartsAndTools;
